import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageElementList from '../../pages/admin/page_elements/PageElementList';
import PageElement from '../../pages/admin/page_elements/PageElement';

function Publishers(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}/:id`} component={PageElement}/>
        <Route exact path={`${path}`} component={PageElementList}/>
      </Switch>
    </Suspense>
	)
}

export default Publishers
